(() => {
  const update = () => {
    const linkValue = new URLSearchParams(window.location.search).get('link');

    document.querySelectorAll('[data-preaccess-flavours]').forEach((picker) => {
      const campaign = picker.dataset.preaccessCampaign;
      if (!campaign) return;

      const storageKey = `sheko-preaccess:${campaign}`;
      let active = linkValue === campaign;

      try {
        if (active) {
          window.sessionStorage.setItem(storageKey, '1');
        } else {
          active = window.sessionStorage.getItem(storageKey) === '1';
        }
      } catch (_) {
        // The URL still opens the campaign view when storage is unavailable.
      }

      picker.hidden = !active;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
  document.addEventListener('shopify:section:load', update);
})();
